import { 
    call,
    takeEvery 
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import UnitFactory from "../../Entity/Factories/UnitFactory";

export default function* unitForUnitDetailsPage(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, `units/${action.payload?.unitId}`);

    const unit = UnitFactory.create(res.data.data);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, unit);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchUnitForUnitDetailsPage() {
  yield takeEvery(Constants.GLOBAL_UNIT_FOR_UNIT_DETAILS_PAGE, unitForUnitDetailsPage);
}
